import { useDispatch } from "react-redux";
import { addtocart } from "../../redux/cart/actions";
import {minusproduct } from "../../redux/product/actions"

function ProductList({product}){
  const {id, name ,category,img,price, qty} = product;  
  const dispatch = useDispatch();   
  function handleAddtoCart(productid){
    if(qty > 0){
    dispatch(addtocart(productid));
    dispatch(minusproduct(productid));
    }
  } 
  return(
        <div className="lws-productCard">
          <img className="lws-productImage" src={img} alt="product" />
          <div className="p-4 space-y-2">
            <h4 className="lws-productName">{name}</h4>
            <p className="lws-productCategory">{category}</p>
            <div className="flex items-center justify-between pb-2">
              <p className="productPrice">BDT <span className="lws-price">{price}</span></p>
              <p className="productQuantity">QTY <span className="lws-quantity">{qty}</span></p>
            </div>
            <button className="lws-btnAddToCart" disabled={qty <= 0 ?? true} onClick={()=>handleAddtoCart(id)}>{qty <= 0 ? 'Out of Stock' : 'Add to Cart'}</button>
          </div>
        </div>
    );
}
export default ProductList;